import React from 'react';
import { getStartedContent } from '../../../utils/getStartedContent';
import PropertyDescriptor, { Type } from '../propertyDescriptor/PropertyDescriptor';
import RequestResponseViewer, { WidgetType } from '../RequestResponse/RequestResponseViewer';
import styles from './getStarted.module.scss';
import { baseResponseBody } from '../../../utils/objectTypeConstants';

interface Props {
    type: 'API Guide' | 'Webhooks Guide' | 'API Errors' | 'Webhook Errors' | 'Authentication Guide' | 'Rate Limiting';
}

const GetStarted: React.FC<Props> = ({ type }) => {
    const renderItems = (items: any[]) => (
        items.map((item, itemIndex) => (
            <li key={itemIndex}>
                <p>
                    {'title' in item && <span className={styles.itemTitle}>{item.title}: </span>}
                    {'description' in item && item.description}
                    {'question' in item && <span className={styles.itemTitle}>{item.question} </span>}
                </p>
                {'answer' in item && (
                    <p className={styles.answer}>
                        {item.answer}
                    </p>
                )}
                {item.subItems && (
                    type === 'API Errors' ? (
                        <ul>
                            {item.subItems.map((subItem: any, subItemIndex: any) => (
                                <li key={subItemIndex}>
                                    <p>
                                        {'title' in subItem && <span className={styles.itemTitle}>{subItem.title}: </span>}
                                        {subItem.description}
                                    </p>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <ol type='a'>
                            {item.subItems.map((subItem: any, subItemIndex: any) => (
                                <li key={subItemIndex}>
                                    <p>
                                        {'title' in subItem && <span className={styles.itemTitle}>{subItem.title}: </span>}
                                        {subItem.description}
                                    </p>
                                </li>
                            ))}
                        </ol>
                    ))}
            </li>
        ))
    );

    const sections = type === 'API Guide' ? getStartedContent.APIGuide
        : type === 'Webhooks Guide' ? getStartedContent.webhooksGuide
            : type === 'API Errors' ? getStartedContent.apiErrors
                : type === 'Authentication Guide' ? getStartedContent.AuthenticationGuide
                    : type === 'Rate Limiting' ? getStartedContent.rateLimiting
                        : getStartedContent.webhookErrors;
    return (
        <div className={styles.container}>
            {sections.map((section, index) => (
                <div key={index} className={styles.sectionContainer}>
                    <div className={styles.sectionHeading}>{section.heading}</div>
                    {section.info && section.info.map((info) => <p className={styles.sectionInfo}>{info}</p>)}
                    {section.items && (
                        section.heading === 'Understanding the Developer Section' ? (
                            <ol>
                                {renderItems(section.items)}
                            </ol>
                        ) : (
                            <ul>
                                {renderItems(section.items)}
                            </ul>
                        )
                    )}
                    {section.note && <p className={styles.sectionNote}><b>Note:</b> {section.note}</p>}
                </div>
            ))}
            {type === 'API Errors' && <div style={{ marginBottom: '25px' }}>
                <PropertyDescriptor value={getStartedContent.errorDescriptionModel[0]} type={Type.CommonErrors} />
                <br />
                <RequestResponseViewer
                    webhookResponseJson={getStartedContent.errorDescriptionModel[1]}
                    widgetType={WidgetType.Webhook}
                    isCollapsable={true}
                    title={{ titleName: 'Error Response' }}
                />
            </div>}
            {type === 'API Guide' && <div style={{ marginBottom: '25px' }}>
                <PropertyDescriptor value={baseResponseBody} type={Type.CommonResponseParameters} />
            </div>}
        </div>
    );
};

export default GetStarted;